import React from 'react'
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

export default function Carouse() {

  const slides = [
    {
      tag: "🚀 Modern Learning",
      title: "Learn Future Skills",
      desc: "Build your career with coding, AI and practical learning experience.",
      btn1: "Connect with our Career Counsellor & Start Learning",
      image: "/11.png",
      floating: ["💻 Live Projects", "🚀 Growth", "⭐ Students", "🔥 Skills"],
    },
    {
      tag: "🔥 AI Classes",
      title: "Build Real Tech Career",
      desc: "Learn web development, AI and digital skills practically.",
      btn1: "Connect with our Career Counsellor & Start Learning",
      image: "/22.png",
      floating: ["📚 Courses", "🎯 Career", "💡 AI Tools", "🚀 Innovation"],
    },
    {
      tag: "⭐ Premium Learning",
      title: "Become Industry Ready",
      desc: "Professional mentorship and real world project experience.",
      btn1: "Connect with our Career Counsellor & Start Learning",
      image: "/44.png",
      floating: ["🔥 Trending", "🚀 Startup", "⭐ Mentors", "💻 Practical"],
    },
    {
      tag: "🚀 Next Generation",
      title: "Upgrade Your Skills",
      desc: "Modern courses designed for future creators and developers.",
      btn1: "Connect with our Career Counsellor & Start Learning",
      image: "/33.png",
      floating: ["🔥 Creativity", "🎯 Future Ready", "🚀 Fast Learning", "⭐ Success"],
    },
  ];

  const [current, setCurrent] = useState(0);
  const nextSlide = () => {
    setCurrent((prev) => prev === slides.length - 1 ? 0 : prev + 1);
  };

  const prevSlide = () => {
    setCurrent((prev) => prev === 0 ? slides.length - 1 : prev - 1);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => prev === slides.length - 1 ? 0 : prev + 1);
    }, 4000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <>
      <div className="main">
        <section className="hero-wrapper">
          <div className="hero">
            {
              slides.map((slide, index) => (
                <div
                  key={index}
                  className={`slide ${current === index ? "active" : ""}`}
                >
                  <div className="grid"></div>
                  <div className="hero-container">

                    {/* LEFT SIDE (TEXT) */}
                    <div className="left">
                      <div className="tag">{slide.tag}</div>
                      <h1>{slide.title}</h1>
                      <p>{slide.desc}</p>
                      
                      <div className="buttons">
                        <Link to="/contact#contact-form" className="btn primary">
                          {slide.btn1}
                        </Link>
                      
                      </div>
                    </div>

                    {/* RIGHT SIDE (IMAGE & SHAPES) */}
                    <div className="right">
                      <div className="glow"></div>
                      <div className="rotate-wrap">
                        <div className="circle circle3"></div>
                        <div className="circle circle1">
                          <div className="dot dot1"></div>
                          <div className="dot dot2"></div>
                        </div>
                        <div className="circle circle2">
                          <div className="dot dot3"></div>
                          <div className="dot dot4"></div>
                        </div>
                      </div>

                      <div className="float float1">{slide.floating[0]}</div>
                      <div className="float float2">{slide.floating[1]}</div>
                      <div className="float float3">{slide.floating[2]}</div>
                      <div className="float float4">{slide.floating[3]}</div>

                      <div className="student">
  <img
    src={slide.image}
    alt={slide.title}
  />
</div>
                      
                     {/* 4. CRITICAL: ARROWS KO APNE IS .right DIV KE ANDAR HI RAKHNA HAI */}
  <div className="slider-arrows">
    <button className="arrow-btn left-arrow" onClick={prevSlide}>❮</button>
    <button className="arrow-btn right-arrow" onClick={nextSlide}>❯</button>
  </div>
</div>

                  </div>
                </div>
              ))
            }

            {/* COUNTER */}
            <div className="counter">
              {String(current + 1).padStart(2, "0")} / {String(slides.length).padStart(2, "0")}
            </div>

       

            {/* INDICATORS */}
            <div className="indicators">
              {
                slides.map((_, index) => (
                  <div
                    key={index}
                    className={`indicator ${current === index ? "active" : ""}`}
                    onClick={() => setCurrent(index)}
                  ></div>
                ))
              }
            </div>

          </div>
        </section>
      </div>
    </>
  )
}